import { useState } from "react";
import classNames from "classnames";
import HTMLReactParser from "html-react-parser";

import { ChevronDownIcon } from "../../AscIcons";

import styles from "./AscQuestionCard.module.scss";
import AscAdminDropdown from "../../AscAdminDropdown/AscAdminDropdown";
import AscButton from "../../AscButton/AscButton";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";

export interface AscQuestionCardProps {
  id?: string;
  className?: string;
  title: string;
  description: string;
  withAction?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
}

export default function AscQuestionCard({
  className,
  title,
  description,
  withAction = false,
  onEdit,
  onDelete,
}: AscQuestionCardProps) {
  const [showText, setShowText] = useState<boolean>(false);

  return (
    <div
      data-testid="asc-question-card"
      className={classNames(
        styles.ground,
        className,
        showText === true && styles.withBorder
      )}
    >
      <div className={styles.topGround}>
        <AscHeading className={styles.header}>{title}</AscHeading>

        <AscButton
          onClick={() => setShowText(!showText)}
          className={classNames(showText ? styles.hideButton : styles.button)}
          icon={<ChevronDownIcon className={styles.icon} />}
        />

        {withAction && (
          <AscAdminDropdown alignment="right" className={styles.dropdown}>
            <AscAdminDropdown.Option onClick={onEdit}>
              Edit
            </AscAdminDropdown.Option>
            <AscAdminDropdown.Option onClick={onDelete}>
              Delete
            </AscAdminDropdown.Option>
          </AscAdminDropdown>
        )}
      </div>
      {showText && <div className={styles.title}>{HTMLReactParser(description)}</div>}
    </div>
  );
}
